import { TranslationKeys } from "./en";

export const es: TranslationKeys = {
  // Loading
  loading: "Cargando encuesta...",
  
  // Thank you page
  thankYou: "¡Gracias!",
  surveySubmitted: "Su respuesta a la encuesta ya ha sido enviada.",
  appreciateParticipation: "Apreciamos su participación y comentarios.",
  
  // Survey closed page
  surveyClosed: "Esta encuesta no acepta respuestas adicionales en este momento. ¡Gracias!",
  
  // Error page
  invalidSurveyLink: "Este no es un enlace de encuesta válido.",
  surveyLoadError: "No se pudo cargar la encuesta. Por favor, verifique la URL e intente nuevamente.",
  
  // No survey data page
  noSurveyAvailable: "No hay encuesta disponible",
  surveyNotFound: "La encuesta que busca no se pudo encontrar o ya no está disponible.",
  
  // Invalid URL page
  invalidSurveyUrl: "URL de encuesta inválida",
  invalidUrlMessage: "El enlace de la encuesta no es válido. Por favor, verifique la URL e intente nuevamente.",
  
  // Survey renderer errors
  submitFailed: "No se pudo enviar la respuesta de la encuesta. Por favor, intente nuevamente.",
  
  // PIN Landing Page
  pinWelcome: "¡Bienvenido! Por favor ingrese su PIN para comenzar.",
  pinInstructions: "Debería haber recibido un PIN de su organización. Ingréselo a continuación para acceder a la encuesta. Los PIN no distinguen entre mayúsculas y minúsculas.",
  enterYourPin: "Ingrese su PIN",
  pinPlaceholder: "por ejemplo, ABC123 o 987654",
  pinError: "PIN inválido. Por favor, intente nuevamente.",
  submit: "Enviar",
  submitting: "Enviando...",
  pinNeedHelp: "¿Necesita ayuda? Contacte a su administrador de recursos humanos para asistencia.",
  poweredByTalentMap: "Desarrollado por TalentMap",
};

